// extracted by mini-css-extract-plugin
export var closeButton = "_e5-1";
export var closeX = "_e5-3";
export var container = "_e5-0";
export var image = "_e5-2";